var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notice)?_c('notice-bar',[_vm._v(_vm._s(_vm.notice))]):_vm._e(),_c('base-form',{ref:"form",attrs:{"items":_vm.data,"label-width":"4em","submitText":"下一步"},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }